"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const ethers_1 = require("ethers");
const TokenAuthority_json_1 = require("../contracts/deploy/TokenAuthority.json");
const constants_1 = require("../constants");
const TokenFactory_1 = require("../contracts/4/TokenFactory");
const getTokenClient = (address, signerOrProvider) => {
    const tokenClient = TokenFactory_1.TokenFactory.connect(address, signerOrProvider);
    tokenClient.clientType = constants_1.ClientType.TokenClient;
    tokenClient.getTokenInfo = () => __awaiter(void 0, void 0, void 0, function* () {
        const name = yield tokenClient.name();
        const symbol = yield tokenClient.symbol();
        const decimals = yield tokenClient.decimals();
        return {
            name,
            symbol,
            decimals,
        };
    });
    tokenClient.deployTokenAuthority = (tokenAddress, colonyAddress, allowedToTransfer) => __awaiter(void 0, void 0, void 0, function* () {
        const tokenAuthorityFactory = new ethers_1.ContractFactory(TokenAuthority_json_1.abi, TokenAuthority_json_1.bytecode, tokenClient.signer);
        const tokenAuthorityContract = yield tokenAuthorityFactory.deploy(tokenAddress, colonyAddress, allowedToTransfer);
        yield tokenAuthorityContract.deployed();
        return tokenAuthorityContract.deployTransaction;
    });
    tokenClient.estimate.deployTokenAuthority = (tokenAddress, colonyAddress, allowedToTransfer) => __awaiter(void 0, void 0, void 0, function* () {
        const tokenAuthorityFactory = new ethers_1.ContractFactory(TokenAuthority_json_1.abi, TokenAuthority_json_1.bytecode);
        const deployTx = tokenAuthorityFactory.getDeployTransaction(tokenAddress, colonyAddress, allowedToTransfer);
        return tokenClient.provider.estimateGas(deployTx);
    });
    return tokenClient;
};
exports.default = getTokenClient;
